import type { CityConfig } from "../city-template/types";

export const restonVaConfig: CityConfig = {
  city: "Reston",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "reston-va",
  route: "/reston-va",
  title: "Emergency Passport Reston, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Reston, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Reston, Herndon, Dulles, Ashburn, Tysons, and all of the Dulles corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Reston, VA",
  heroSubtitle: "Passport expired before your international business trip? Need an emergency passport fast? We help Reston and Dulles corridor travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Modern%20Reston%20Virginia%20skyline%20at%20golden%20hour%20with%20Reston%20Town%20Center%20glass%20towers%2C%20contemporary%20urban%20architecture%20mixed%20with%20green%20tree-lined%20streets%2C%20warm%20sunset%20light%20reflecting%20off%20modern%20office%20buildings%2C%20professional%20photography%20with%20clean%20geometric%20lines%20and%20warm%20golden%20tones%2C%20no%20people%20visible%2C%20tech%20hub%20suburb%20with%20elegant%20urban%20planning%20and%20natural%20beauty&width=1800&height=700&seq=reston-va-hero-001&orientation=landscape",
  heroImageAlt: "Modern Reston Virginia skyline at golden hour with Reston Town Center glass towers and contemporary urban architecture",
  geoPosition: "38.9586;-77.3570",
  geoPlacename: "Reston, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 22 miles from Reston via Dulles Toll Road and I-66",
  },
  nearbyCitiesZips: [
    { name: "Reston", zips: "20190, 20191, 20192, 20193, 20194" },
    { name: "Herndon", zips: "20170, 20171, 20172" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033" },
    { name: "Vienna", zips: "22180, 22181, 22182" },
    { name: "McLean", zips: "22101, 22102" },
    { name: "Tysons Corner", zips: "22102" },
    { name: "Ashburn", zips: "20147, 20148" },
    { name: "Sterling", zips: "20164, 20165" },
    { name: "Chantilly", zips: "20151, 20152" },
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Great Falls", zips: "22066" },
    { name: "Oakton", zips: "22124" },
    { name: "Burke", zips: "22015" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153" },
    { name: "Annandale", zips: "22003" },
    { name: "Falls Church", zips: "22040, 22041, 22042, 22043, 22044, 22046" },
    { name: "Leesburg", zips: "20175, 20176" },
    { name: "Dulles", zips: "20166" },
    { name: "Manassas", zips: "20110, 20111" },
    { name: "Woodbridge", zips: "22191, 22192, 22193" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22213, 22214, 22217" },
    { name: "Alexandria", zips: "22301, 22302, 22303, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Dulles corridor departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Dulles Corridor Hub", desc: "Serving Reston, Herndon, Ashburn, and all of Northern Virginia" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Fairfax VA passport services", route: "/fairfax-va" },
    { name: "Vienna VA passport services", route: "/vienna-va" },
    { name: "McLean VA passport services", route: "/mclean-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Reston remotely via secure courier. We do not have a walk-in office in Reston — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Reston and Dulles corridor travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Reston and the surrounding Dulles corridor area including Herndon, Ashburn, Sterling, Chantilly, Fairfax, Vienna, McLean, Tysons Corner, and all of Northern Virginia",
  serviceAreaIntro: "From the sleek towers of Reston Town Center to the quiet neighborhoods of North Point and South Lakes, from the historic charm of Lake Anne to the tech corridors near Dulles Airport — Fast Passport Center serves every corner of Reston and the Dulles corridor. We regularly help travelers from Herndon, Ashburn, Sterling, Chantilly, Fairfax, and Tysons get their passports fast.",
  nearbyCitiesIntro: "We serve all Reston neighborhoods and the surrounding Dulles corridor metro area including Herndon, Fairfax, Vienna, McLean, Tysons Corner, Ashburn, Sterling, Chantilly, Centreville, Great Falls, Oakton, Burke, Springfield, Annandale, Falls Church, Leesburg, Manassas, Woodbridge, Arlington, and Alexandria. If you are anywhere in the Dulles corridor or Northern Virginia region, we have you covered.",
  howItWorksIntro: "Most Reston travelers complete everything online and ship documents overnight. No need to drive into Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Reston travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Reston and Dulles corridor travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Reston? Here are the most common ones we hear from Dulles corridor travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Reston and Fairfax County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Fairfax County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.fairfaxcounty.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Fairfax County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.fairfaxcounty.gov/" },
  ],
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Reston international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michael T.",
      location: "Reston, VA",
      rating: 5,
      text: "Business trip to London in 4 days and my passport had expired. Fast Passport Center had my renewal processed in 3 days. I shipped from the UPS near Reston Town Center and never missed my flight. Outstanding service for busy professionals.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah K.",
      location: "Herndon, VA",
      rating: 5,
      text: "Emergency passport for a tech conference in Singapore. I was panicking because my company had already booked everything. Fast Passport Center delivered in 36 hours. Their knowledge of the Dulles corridor area made everything seamless.",
      service: "Emergency Passport",
    },
    {
      name: "James R.",
      location: "Ashburn, VA",
      rating: 5,
      text: "First passports for my two kids before our family trip to Italy. Fast Passport Center handled the parental consent requirements and had both passports in 5 days. The Reston-area service was incredibly convenient for our busy schedule.",
      service: "Child Passport",
    },
    {
      name: "Lisa M.",
      location: "Sterling, VA",
      rating: 5,
      text: "Lost my passport 48 hours before a flight to Frankfurt for work. I was absolutely panicking. Fast Passport Center had a replacement in my hands in 30 hours. They saved an important client meeting that I had been preparing for months.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "reston-va-1",
      name: "Reston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11110 Sunset Hills Rd",
      city: "Reston",
      state: "VA",
      zip: "20190",
      phone: "(703) 476-3741",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Reston, near Reston Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Reston facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "reston-va-2",
      name: "Herndon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "840 Herndon Pkwy",
      city: "Herndon",
      state: "VA",
      zip: "20170",
      phone: "(703) 437-9681",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Herndon, east of Reston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Herndon and east Reston area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "reston-va-3",
      name: "Fairfax County Clerk — North County",
      type: "County Clerk Passport Acceptance",
      address: "1801 Cameron Glen Dr",
      city: "Reston",
      state: "VA",
      zip: "20190",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "North Reston Government Center",
      website: "https://www.fairfaxcounty.gov/",
      websiteLabel: "Fairfax County Clerk",
      notes: "Major county facility for northern Fairfax County. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "reston-va-4",
      name: "Chantilly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14004 Thunderbolt Pl",
      city: "Chantilly",
      state: "VA",
      zip: "20151",
      phone: "(703) 378-1145",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chantilly, near Dulles Airport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chantilly and Dulles Airport area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "reston-va-5",
      name: "Sterling Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "209 E Frederick Dr",
      city: "Sterling",
      state: "VA",
      zip: "20164",
      phone: "(703) 430-6114",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling, west of Reston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sterling and western Loudoun County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "reston-va-6",
      name: "Fairfax Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4000 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 359-4276",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fairfax City, south of Reston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fairfax City and south Reston area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Reston photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Dulles corridor acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Reston applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Reston families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Reston travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Reston or Herndon." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Reston address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Reston before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Reston for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive into downtown Washington, DC." },
    { q: "How fast can I renew my passport in Reston?", a: "Fast Passport Center offers fast passport renewal in Reston in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Reston?", a: "The nearest regional passport agency to Reston is the Washington Passport Agency, located approximately 22 miles away in downtown Washington, DC. For urgent processing without navigating DC traffic and parking, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Reston without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Reston?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Reston residents." },
    { q: "Can I expedite a child passport in Reston?", a: "Yes. Fast Passport Center expedites child passports in Reston for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Reston families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Reston with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Reston?", a: "With Fast Passport Center's emergency courier service, Reston travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Reston?", a: "Popular options include the Reston Post Office (20190), Herndon Post Office (20170), Fairfax County Clerk — North County (20190), Chantilly Post Office (20151), Sterling Post Office (20164), and Fairfax Main Post Office (22030). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Reston?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC traffic and parking hassle." },
    { q: "What if I live in a smaller Dulles corridor town?", a: "We serve the entire Dulles corridor and Northern Virginia region including Herndon, Ashburn, Sterling, Chantilly, Centreville, Fairfax, Vienna, McLean, Tysons, Great Falls, Oakton, Burke, Springfield, Annandale, Falls Church, Leesburg, Manassas, and Woodbridge. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Reston?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Reston?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Reston, Herndon, and Ashburn offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Reston?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Reston?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Reston families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Reston", address: "11160 South Lakes Dr, Reston, VA 20191", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Reston", address: "11777 Sunrise Valley Dr, Reston, VA 20191", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Reston", address: "11900 Freedom Dr, Reston, VA 20190", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Herndon", address: "460 Herndon Pkwy, Herndon, VA 20170", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Ashburn", address: "43670 Yukon Dr, Ashburn, VA 20147", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Chantilly", address: "14101 Sullyfield Cir, Chantilly, VA 20151", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Sterling", address: "460 E Maple Ave, Sterling, VA 20164", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Fairfax", address: "13050 Lee Jackson Memorial Hwy, Fairfax, VA 22033", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Reston",
      address: "11660 Sunrise Valley Dr, Reston, VA 20191",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Sterling",
      address: "455 E Maple Ave, Sterling, VA 20164",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "4110 Chain Bridge Rd, Fairfax, VA 22030",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Fairfax and south Reston residents. REAL ID available.",
      featured: true,
    },
    {
      name: "Virginia DMV — Tysons",
      address: "1960 Chain Bridge Rd, Tysons, VA 22102",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves eastern Fairfax County and Tysons area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "7 miles west of Reston",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The primary international airport for Reston and the Dulles corridor. Major hub for long-haul flights to Europe, Asia, and the Middle East — perfect for Reston's tech professionals. Accessible via Dulles Toll Road and Route 28.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "22 miles southeast of Reston",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Alternative major airport for domestic flights and international connections. Accessible via I-66 and GW Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "55 miles northeast of Reston",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for international flights. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};